
// components/MailSms/components/SendTab/index.js
import React from 'react';
import { FiUsers, FiBook } from 'react-icons/fi';
import StudentSelection from './StudentSelection';
import LessonSelection from './LessonSelection';
import MessageForm from './MessageForm';

const SendTab = ({
  activeTab,
  smsSendType,
  setSmsSendType,
  students,
  lessons,
  selectedStudents,
  setSelectedStudents,
  selectedLessons,
  setSelectedLessons,
  searchTerm,
  setSearchTerm,
  lessonSearchTerm,
  setLessonSearchTerm,
  filteredStudents,
  filteredLessons,
  studentPagination,
  lessonPagination,
  loadMoreStudents,
  loadMoreLessons,
  emailForm,
  setEmailForm,
  smsForm,
  setSmsForm,
  emailTemplates,
  smsTemplates,
  smsSettings,
  handleSendEmail,
  handleSendSms,
  loading,
  dataLoading
}) => {
  return (
    <div>
      {/* SMS Type Selection for SMS Tab */}
      {activeTab === 'sms' && (
        <div className="mb-6 flex space-x-4">
          <button
            onClick={() => setSmsSendType('student')}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              smsSendType === 'student' 
                ? 'bg-purple-600 text-white' 
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            <FiUsers className="inline mr-2" />
            Öğrencilere SMS
          </button>
          <button
            onClick={() => setSmsSendType('lesson')}
            className={`px-4 py-2 rounded-lg font-medium transition-colors ${
              smsSendType === 'lesson' 
                ? 'bg-purple-600 text-white' 
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            <FiBook className="inline mr-2" />
            Ders Bilgilendirme SMS
          </button>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Selection Column */}
        <div className="bg-gray-50 rounded-lg p-6">
          {activeTab === 'email' || smsSendType === 'student' ? (
            <StudentSelection
              students={filteredStudents}
              selectedStudents={selectedStudents}
              setSelectedStudents={setSelectedStudents}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              dataLoading={dataLoading}
              allStudents={students}
              pagination={studentPagination}
              onLoadMore={loadMoreStudents}
            />
          ) : (
            <LessonSelection
              lessons={filteredLessons}
              selectedLessons={selectedLessons}
              setSelectedLessons={setSelectedLessons}
              lessonSearchTerm={lessonSearchTerm}
              setLessonSearchTerm={setLessonSearchTerm}
              dataLoading={dataLoading}
              allLessons={lessons}
              pagination={lessonPagination}
              onLoadMore={loadMoreLessons}
            />
          )}
        </div>

        {/* Message Form */}
        <div className="bg-gray-50 rounded-lg p-6">
          <MessageForm
            activeTab={activeTab}
            smsSendType={smsSendType}
            emailForm={emailForm}
            setEmailForm={setEmailForm}
            smsForm={smsForm}
            setSmsForm={setSmsForm}
            emailTemplates={emailTemplates}
            smsTemplates={smsTemplates}
            smsSettings={smsSettings}
            selectedLessons={selectedLessons}
            lessons={lessons}
            handleSendEmail={handleSendEmail}
            handleSendSms={handleSendSms}
            loading={loading}
            selectedStudents={selectedStudents}
          />
        </div>
      </div>
    </div>
  );
};

export default SendTab;
